<script setup lang="ts">
/**
 * 審査ステータスのアイコン。
 *
 * 【選定の考え方】
 * 業務の流れ「準備 → 審査 → 結果(OK/NG)」が、アイコンを見ただけで
 * 追えるようにしている。色だけに頼らないことで、
 *   - 色覚特性のある方でも状態を区別できる
 *   - モノクロ印刷やスクリーンショットでも意味が伝わる
 * という利点もある(色は補助、形が主)。
 */
defineProps<{ name: string }>()
</script>

<template>
  <svg class="status-tab-icon" viewBox="0 0 24 24" aria-hidden="true">
    <!-- すべて: 一覧(リスト) -->
    <g v-if="name === 'list'">
      <line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="18" x2="21" y2="18" /><line x1="3" y1="6" x2="3.01" y2="6" />
      <line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" />
    </g>
    <!-- 準備: 時計(これから着手する = 待ち) -->
    <g v-else-if="name === 'clock'">
      <circle cx="12" cy="12" r="9" /><polyline points="12 7 12 12 15.5 14" />
    </g>
    <!-- 審査中: 虫めがね(今まさに調べている) -->
    <g v-else-if="name === 'search'">
      <circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.2" y2="16.2" />
    </g>
    <!-- 保留: 一時停止(判断を止めている) -->
    <g v-else-if="name === 'pause'">
      <line x1="9.5" y1="5" x2="9.5" y2="19" /><line x1="14.5" y1="5" x2="14.5" y2="19" />
    </g>
    <!-- 審査OK: チェック -->
    <g v-else-if="name === 'check'">
      <polyline points="4 12.5 9.5 18 20 6.5" />
    </g>
    <!-- 出品NG: 禁止(出品してはいけない) -->
    <g v-else-if="name === 'ban'">
      <circle cx="12" cy="12" r="9" /><line x1="5.6" y1="18.4" x2="18.4" y2="5.6" />
    </g>
    <!-- 審査NG: バツ -->
    <g v-else>
      <line x1="6" y1="6" x2="18" y2="18" /><line x1="18" y1="6" x2="6" y2="18" />
    </g>
  </svg>
</template>
